<template>
    <div id="chapter" class="container page">
        <div class="row">
            <div class="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                <trivia v-if="chapter.type === 'trivia'">
                    <back-button :back-route="backRoute"></back-button>
                </trivia>
                <article-chapter v-else-if="chapter.type === 'article'">
                    <back-button :back-route="backRoute"></back-button>
                </article-chapter>
                <video-chapter v-else-if="chapter.type === 'video'">
                    <back-button :back-route="backRoute"></back-button>
                </video-chapter>
                <div v-else-if="chapter.type" class="row">
                    <back-button :back-route="backRoute"></back-button>
                    <div class="col-xs-12">
                        <h1>{{ chapter.name }}</h1>
                    </div>

                    <div class="col-xs-12 chapter-content" v-html="chapter.content">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
    import { mapGetters } from "vuex";

    import log from 'src/services/logger';
    import BackButton from "Components/common/BackButton/BackButton";
    import Trivia from "./Trivia.vue";
    import ArticleChapter from "./ArticleChapter.vue";
    import VideoChapter from "./VideoChapter.vue";
    const logTag = "Chapter";

    export default {
        name : "Chapter",

        components : {Trivia, ArticleChapter, VideoChapter, BackButton},

        created : function() {
            this.$store.dispatch("emptyChapter");
            this.initChapter();
            this.chapterOpened();
        },

        props : {

        },

        computed : {
            ...mapGetters([
                "chapter",
            ]),
            backRoute() {
                return {name: 'categoryDashboard', params: {category: this.$route.params.category}};
            }
        },

        data() {
            return {};
        },

        methods: {
            initChapter() {
                const categoryId = this.$route.params.category;
                const chapterId = this.$route.params.chapter;
                return this.$store.dispatch("downloadChapter", {categoryId: categoryId, chapterId: chapterId})
                    .catch(reason => {
                        log.log(logTag, "Download chapter error, reason follows:");
                        log.log(logTag, reason);
                    });
            },

            chapterOpened() {
                const categoryId = this.$route.params.category;
                const chapterId = this.$route.params.chapter;
                this.$store.dispatch("chapterOpened", {categoryId: categoryId, chapterId: chapterId})
                    .catch(reason => {
                        log.log(logTag, "Confirm chapter error, reason follows:");
                        log.log(logTag, reason);
                    });
            }
        }
    };
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
